export const roundOffPosition = (position: string, tags?: string[]) => {
	if (tags?.length && tags.some((label) => label === 'latitude' || label === 'longitude')) {
		return Number(position).toFixed(5);
	}

	return Number(position).toFixed(1);
};
